import { render } from "./AddExpenseComponent.vue?vue&type=template&id=7c96eddf&scoped=true"
import script from "./AddExpenseComponent.vue?vue&type=script&lang=js"
export * from "./AddExpenseComponent.vue?vue&type=script&lang=js"

import "./AddExpenseComponent.vue?vue&type=style&index=0&id=7c96eddf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c96eddf"]])

export default __exports__